import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  PrimaryButton,
  ButtonSizes,
} from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';
import { MemberAvatar } from 'app/src/components/MemberAvatar';
import Icon, {
  IconName,
  IconColor,
} from 'app/common/components/controls/icon_DO_NOT_USE';
import { identityBaseUrl } from '@trello/config';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});

const twoFactorSetupUrl = `${identityBaseUrl}/manage-profile/security`;

interface NotWorkProps {
  id: string;
  name: string;
  aaEmail: string;
  orgName?: string;
  onDismiss: () => void;
  onClickOk: () => void;
}

const ListItem: FunctionComponent<{}> = ({ children }) => (
  <div className={styles.listItem}>
    <Icon
      large
      className={styles.atlassianConfirmationIcon}
      color={IconColor.Green}
      name={IconName.Check}
    />
    <span>{children}</span>
  </div>
);

export const AtlassianConfirmation: FunctionComponent<NotWorkProps> = ({
  id,
  name,
  aaEmail,
  orgName,
  onDismiss,
  onClickOk,
}) => (
  <OnboardingDialog
    title={format('account connected title')}
    // Only show the help link for managed accounts
    helpLink={orgName && AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    className={styles.notWorkBody}
  >
    <div className={styles.confirmationContent}>
      <div className={styles.leftSection}>
        <MemberAvatar size={64} idMember={id} />
        <p title={name}>{name}</p>
        <span title={aaEmail}>{aaEmail}</span>
      </div>
      <div className={styles.rightSection}>
        <ListItem>
          <span>{format('fron now on')}</span>
        </ListItem>
        {!orgName && (
          <ListItem>
            <a href={twoFactorSetupUrl}>
              <u>{format('configure two factor')}</u>
            </a>
          </ListItem>
        )}
        <ListItem>
          {format('to review profile')}{' '}
          <a href={identityBaseUrl + '/manage-profile'}>
            <u>{format('atlassian profile')}</u>
          </a>
        </ListItem>

        {orgName && (
          <ListItem>
            {format('non org boards', { org: orgName })}
            <a href={AtlassianAccountOnboardingLinks.TransferBoards}>
              <u> {format('transfer to personal')}</u>
            </a>
          </ListItem>
        )}
        <div className={styles.buttonSection}>
          <PrimaryButton size={ButtonSizes.WIDE} onClick={onClickOk}>
            {format('got it')}
          </PrimaryButton>
        </div>
      </div>
    </div>
  </OnboardingDialog>
);
